// In this file, all Page components from 'src/pages` are auto-imported. Nested
// directories are supported, and should be uppercase. Each subdirectory will be
// prepended onto the component name.
//
// Examples:
//
// 'src/pages/HomePage/HomePage.js'         -> HomePage
// 'src/pages/Admin/BooksPage/BooksPage.js' -> AdminBooksPage

import { Route, Router, Set } from "@redwoodjs/router";

import PrerenderLoading from "src/components/PrerenderLoading/PrerenderLoading";
import DashboardLayout from "src/layouts/DashboardLayout/DashboardLayout";

import { useAuth } from "./lib/auth";

const Routes = () => {
  return (
    <Router useAuth={useAuth}>
      <Route path="/" page={HomePage} name="home" />
      <Route path="/blog" page={BlogPage} name="blog" />
      <Route path="/blog/{slug}" page={BlogEntryPage} name="blogEntry" />
      <Route path="/guides" page={GuidesRedirectPage} name="guides" />
      <Route path="/guides/{slug}" page={GuidesRedirectPage} name="guideEntry" />
      <Route path="/preview/{token}" page={ContentPreviewPage} name="contentPreview" />
      <Route path="/eula" page={EulaPage} name="eula" />
      <Route path="/privacy-policy" page={PrivacyPolicyPage} name="privacyPolicy" />
      <Route path="/login" page={LoginPage} name="login" />
      <Route path="/notifications/unsubscribe" page={NotificationUnsubscribePage} name="notificationUnsubscribe" />
      <Route path="/redirect/shopify" page={ShopifyRedirectPage} name="redirectShopify" />

      <Set wrap={DashboardLayout} prerender whileLoadingPage={PrerenderLoading}>
        <Route path="/dashboard" page={DashboardPage} name="dashboard" prerender={false} />
        <Route path="/analytics" page={AnalyticsPage} name="analytics" prerender={false} />
        <Route path="/analytics/{child}" page={AnalyticsPage} name="analytics" prerender={false} />
        <Route path="/finance" page={FinancePage} name="finance" prerender={false} />
        <Route path="/finance/{child}" page={FinancePage} name="finance" prerender={false} />
        <Route path="/marketing" page={MarketingPage} name="marketing" prerender={false} />
        <Route path="/marketing/{child}" page={MarketingPage} name="marketing" prerender={false} />
        <Route path="/admin" page={AdminPage} name="admin" prerender={false} />
        <Route path="/admin/content" page={AdminContentRedirectPage} name="adminContent" prerender={false} />
        <Route path="/admin/content/new" page={AdminContentEditorPage} name="adminContentNew" prerender={false} />
        <Route path="/admin/content/{id}" page={AdminContentEditorPage} name="adminContentEntry" prerender={false} />

        {/* Hidden pages */}
        <Route path="/callback/{type...}" page={CallbackPage} name="callback" prerender={false} />
      </Set>

      <Route notfound page={NotFoundPage} />
    </Router>
  );
};

export default Routes;
